import { getTarget } from '../../../utils/location';
import Button from '../../atoms/button/button';
import './modalPermissions.scss';

interface ModalPermissionsInterface {
    closeModal: () => void;
    isMobile: boolean;
    content: {
        imagen: any;
        nombre: string;
        subtitulo?: string;
        referencias: any[];
        [any: string]: any;
    };
}

const ModalPermissions = (props: ModalPermissionsInterface) => {
    const { imagen, nombre, subtitulo, referencias } = props.content ?? {};

    const setModalClose = () => {
        props.closeModal();
    };

    const setValueClose = () => {
        setModalClose();
    };

    return (
        <div className={'m-not-permissions-modal'}>
            <div className="m-not-permissions-modal__content">
                <div className="m-not-permissions-modal__exit">
                    <i
                        className="icon icon-close m-not-permissions-modal__exit-icon"
                        onClick={setModalClose}
                    />
                </div>
                {props.content && (
                    <div className="m-not-permissions-modal__container">
                        <img
                            className="m-not-permissions-modal__container-icon"
                            src={imagen[0].file.url}
                            alt={imagen[0].title}
                            title={imagen[0].title}
                        />
                        <h3
                            className={
                                subtitulo
                                    ? 'm-not-permissions-modal__container-title-with-subtitle'
                                    : 'm-not-permissions-modal__container-title'
                            }
                        >
                            {nombre}
                        </h3>
                        {subtitulo && (
                            <p className="m-not-permissions-modal__container-subtitle">
                                {subtitulo}
                            </p>
                        )}
                        {referencias[0] && (
                            <Button
                                type="button"
                                classname="m-not-permissions-modal__container-button modal"
                                text={referencias[0].copyBoton}
                                isDisabled={false}
                                onClickAction={setValueClose}
                            />
                        )}

                        {referencias[1] && (
                            <>
                                <hr className="m-not-permissions-modal__container-separator" />
                                <a
                                    className="m-not-permissions-modal__container-exit"
                                    href={referencias[1].redireccion}
                                    target={getTarget(
                                        referencias[1].redireccion
                                    )}
                                    rel="noopener noreferrer"
                                    title={referencias[1].copyBoton}
                                >
                                    {referencias[1].copyBoton}
                                </a>
                            </>
                        )}
                    </div>
                )}
            </div>
            <div
                className="m-not-permissions-modal__bkg"
                onClick={setModalClose}
            ></div>
        </div>
    );
};

export default ModalPermissions;
